export const ru = {
    services_not_choosed: 'Услуги не выбраны',
    time: 'Время локальное',
    timeline_title: 'Маршрут',
};
